module.exports = __webpack_public_path__ + "img/sum_assured_white.c4a0345.svg";